<dx-stepper
    class="status-stepper"
    [class.status-stepper--readonly]="readOnly()"
    [orientation]="orientation()"
    [linear]="false"
    [items]="items()"
    [selectedIndex]="selectedIndex()"
    [focusStateEnabled]="!readOnly()"
    [hoverStateEnabled]="!readOnly()"
    [activeStateEnabled]="!readOnly()"
    [selectOnFocus]="!readOnly()"
    (onSelectionChanging)="onSelectionChanging($event)"
    (onItemRendered)="onItemRendered($event)"
>
    <div *dxTemplate="let data of 'item'" class="dx-step-content" [attr.id]="data.targetId">
        @if (data.description) {
            <dx-tooltip [target]="'#' + data.targetId" class="status-stepper__tooltip">
                <div *dxTemplate="let _ of 'content'">
                    {{ data.description }}
                </div>
            </dx-tooltip>
        }
        <div class="dx-step-indicator">
            @if (data.iconClass) {
                <i class="status-stepper__icon {{ data.iconClass }}" aria-hidden="true"></i>
            }
        </div>
        @if (data.label) {
            <div class="dx-step-caption">
                <div class="dx-step-label">{{ data.label }}</div>
            </div>
        }
    </div>
</dx-stepper>
